import { render, staticRenderFns } from "./StockStatistics.vue?vue&type=template&id=0428e92b&scoped=true"
import script from "./StockStatistics.vue?vue&type=script&lang=js"
export * from "./StockStatistics.vue?vue&type=script&lang=js"
import style0 from "./StockStatistics.vue?vue&type=style&index=0&id=0428e92b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0428e92b",
  null
  
)

export default component.exports